<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed, ref, Ref } from 'vue'
import { useErrorStore } from '@/stores/errorStore'
import TheIcon from '@/components/atoms/TheIcon/TheIcon.vue'

const errorStore = useErrorStore()
const { error } = storeToRefs(errorStore)
let visibility: Ref<string> = ref('visible')
let clearErrorTimeout = 0
let visibilityTimeout = 0

visibility.value = 'hidden'

// Error banner is disabled - only error dialog modal is shown
const showError = computed(() => {
    return false
})
</script>
<template>
    <div
        class="error-message"
        id="error-message"
        :class="{ 'error-message--show': showError }"
        :style="'visibility:' + visibility"
    >
        <div class="container-fluid">
            <p class="error-message__text" v-html="error?.message"></p>
            <button
                class="error-message__button"
                @click="errorStore.clearError()"
            >
                <TheIcon
                    name="close"
                    color="white"
                    class="error-message__button-icon"
                />
            </button>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.error-message {
    background-color: $dn-red;
    position: sticky;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 950;
    transform: translateY(-100%);
    transition: 0.3s ease-out transform;
    padding: rem(20) 0;
    margin: 0 rem(-16);
    margin-bottom: rem(-40px);

    &.error-message--show {
        transform: translateY(0);
    }

    &__text {
        font-size: rem(16);
        color: $dn-white;
        font-weight: 600;
        margin: 0;
        text-align: center;
        margin-right: rem(30);

        @include media-breakpoint-up(sm) {
            font-size: rem(20);
            margin-right: rem(40);
        }
    }

    &__button {
        outline: none;
        border: none;
        background-color: transparent;
        position: absolute;
        top: 50%;
        right: 1rem;
        transform: translateY(-50%);
        color: $dn-white;
        padding: rem(12) 0 rem(12) rem(12);

        @include media-breakpoint-up(sm) {
            right: calc(1.0425rem + 1.7354166667vw);
        }

        &-icon {
            font-size: rem(20);

            @include media-breakpoint-up(sm) {
                font-size: rem(24);
            }
        }
    }
}
</style>
